/* eslint-disable */
import React from 'react';
// import { showMessage, hideMessage, MessageOptions } from "react-native-flash-message";
import { IMessage } from '../interfaces/IMessage';

const sendMessage = (option: any) => {
  // showMessage({ ...option, style: { paddingTop: 50 }, duration: 5000 });
};

export default sendMessage;
